import React from 'react';
import { Route } from 'react-router-dom';
import { QuizShowGameListPage, QuizShowGamePlayPage } from './component/quizshow';
import { QuizAdminGameListPage, QuizAdminGamePlayerPage, QuizAdminGameQuizListPage, QuizAdminScoreBoardPage } from './component/quizshowadmin';
import { QuizSpeedHomePage } from './component/quizshowspeed';

class RouteGroupQuizShow extends React.Component {
  render() {
    return (
      <>
        {/* quizshow */}
        <Route exact path={"/quizshow"} component={QuizShowGameListPage} />
        <Route exact path={"/quizshow/:gameId([0-9]+)"} component={QuizShowGamePlayPage} />

        {/* quizshow admin */}
        <Route exact path={"/quizshow-admin"} component={QuizAdminGameListPage} />
        <Route exact path={"/quizshow-admin/:gameId([0-9]+)"} component={QuizAdminGameQuizListPage} />
        <Route exact path={"/quizshow-admin/:gameId([0-9]+)/player"} component={QuizAdminGamePlayerPage} />
        <Route exact path={"/quizshow-admin/score"} component={QuizAdminScoreBoardPage} />
        <Route exact path={"/quizshow-speed"} component={QuizSpeedHomePage} />
      </>
    );
  }
}

export { RouteGroupQuizShow };
